module.exports = __webpack_public_path__ + "img/20221115楼书3.20b48284.png";